import React from 'react'

function Map() {
    return (
        <div>
            <section className="contact-map">
                <div className="container">
                    <div className="google-map google-map__contact">
                        <iframe
                            title="template google map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.0851034893594!2d-0.20521302411253817!3d5.554402194425997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9099050ee617%3A0xec1887b5b7a1893d!2sMovenpick%20Ambassador%20Hotel%20Accra!5e0!3m2!1sen!2sgh!4v1775546893900!5m2!1sen!2sgh" 
                            className="map__contact"
                            allowFullScreen=""
                        />
                        
                    </div>
                    {/* /.google-map */}
                </div>
                {/* /.container-fluid */}
            </section>

        </div>
    )
}

export default Map